import React, { Component } from 'react';

import { SCREEN_ID_SUNSETUP_DRIVER_ORDERS } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrSunSetupDriverOrders from 'client/components/SrSunSetupDriverOrders/SrSunSetupDriverOrders';
import SrBox from 'client/components/SrBox';
import SrButton, { SR_BUTTON_THEME_ADOBE_BLUE } from 'client/components/SrButton/SrButton';

@withTransitionHook
@withScreenId(SCREEN_ID_SUNSETUP_DRIVER_ORDERS)
@withScrollToTop
class SunSetupDriverOrdersPage extends Component {
  render() {
    const { match, history } = this.props;

    const backUrl = history.location.pathname;
    const itemRegistrationUrl = `/sunsetup/register-item?backUrl=${backUrl}`;

    return (
      <SrPartnerPageV2 navbarTitle="SunSetup">
        <SrBox margin="0 0 20px 0">
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_BLUE}
            onClick={() => {
              history.push(itemRegistrationUrl);
            }}
          >
            Scan Item
          </SrButton>
        </SrBox>
        <SrSunSetupDriverOrders driverId={parseInt(match.params.driverId, 10)} />
      </SrPartnerPageV2>
    );
  }
}

SunSetupDriverOrdersPage.displayName = 'SunSetupDriverOrdersPage';

export default SunSetupDriverOrdersPage;
